<script setup lang="ts">
import { ToastContainer } from 'vue-toastflow'
import { RouterView } from 'vue-router'
import PageActions from '@/components/custom/page-actions/PageActions.vue'
</script>

<template>
  <ToastContainer />

  <RouterView />

  <!-- Global dark mode toggle (with language switch nested inside) floating at bottom-left -->
  <PageActions />
</template>
